import React from "react";
import withLoaderData from "../../../components/withLoaderData";
import { connect } from "react-redux";

import * as DataDelegator from "../../../components/smart/delegator/DataDelegator";
import { Editor } from "@monaco-editor/react";

class AggregateEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pipelineValid: true,
        }

        this.handlePipelineValidation = this.handlePipelineValidation.bind(this);
    }

    handlePipelineValidation(markers) {
        this.setState({
            pipelineValid: markers.length == 0,
        })
    }

    render() {
        return (
            <div className="row mt-4">
                <div className="col-sm-12">
                    <label className="font-bold">Editor:</label>

                    {!this.state.pipelineValid &&
                        <div className="alert alert-danger" role="alert">
                            <div className="row">
                                <div className="col-9">
                                    Invalid Pipeline JSON
                                </div>
                            </div>
                        </div>
                    }

                    <Editor
                        height="100vh"
                        defaultLanguage="json"
                        theme="vs-dark"
                        autoIndent={true}
                        onChange={this.props.onChange}
                        onValidate={this.handlePipelineValidation}
                        value={this.props.value}
                        
                    />
                </div>
            </div>
        )
    }
}

export default withLoaderData(connect(DataDelegator.mapStateToProps)(AggregateEditor));